import React from 'react';
import { Link } from 'react-router-dom';
export function HomeHeroInfo() {
  return <div className="flex flex-col items-start" data-id="element-1717">
      <div className="inline-block bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-1718">
        New Student Trial Available
      </div>
      <div className="mb-8 inline-flex flex-nowrap items-center gap-3 text-sm md:text-base font-bold text-ink bg-white/90 backdrop-blur-sm py-2 px-4 rounded-full shadow-sm border border-subtle-gray w-fit max-w-full whitespace-nowrap" data-id="element-1719">
        <span className="text-gold tracking-wider shrink-0" data-id="element-1720">★★★★★</span>
        <span className="text-subtle-gray shrink-0" data-id="element-1721">|</span>
        <span className="shrink-0" data-id="element-1722">5.0 Rating From 201 Reviews</span>
      </div>
      <h1 className="text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-[1.1]" data-id="element-1723">
        Taekwondo Classes & Martial Arts Programs in Farmington Hills
      </h1>
      <p className="text-xl text-off-white mb-8 max-w-xl leading-relaxed" data-id="element-1724">
        Storm Taekwondo offers structured classes and programs for kids ages 3+,
        adults, and families. Students build confidence, focus, discipline,
        fitness, and real taekwondo skills in a positive coaching environment.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-6" data-id="element-1725">
        <Link to="/SignMeUp" className="btn-primary" data-id="element-1726">
          Start With a Trial Class
        </Link>
        <Link to="/Programs.html" className="btn-secondary" data-id="element-1727">
          View Classes & Programs
        </Link>
      </div>
      <p className="text-sm text-gray-warm mb-8" data-id="element-1728">
        No experience needed • Ages 3+ • Kids, adults, and families welcome
      </p>
      <div className="flex flex-wrap items-center gap-2" data-id="element-1729">
        <span className="inline-block bg-white/10 text-white border border-white/20 px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide" data-id="element-1730">
          Kids • Adults • Families
        </span>
        <span className="inline-block bg-white/10 text-white border border-white/20 px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide" data-id="element-1731">
          Beginner Friendly
        </span>
        <span className="inline-block bg-storm-red text-white px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-wide" data-id="element-1732">
          Summer Camp Available
        </span>
      </div>
    </div>;
}